import { render, staticRenderFns } from "./sw-model-rename.vue?vue&type=template&id=0915a99e&"
import script from "./sw-model-rename.vue?vue&type=script&lang=js&"
export * from "./sw-model-rename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0915a99e')) {
      api.createRecord('0915a99e', component.options)
    } else {
      api.reload('0915a99e', component.options)
    }
    module.hot.accept("./sw-model-rename.vue?vue&type=template&id=0915a99e&", function () {
      api.rerender('0915a99e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Model/Rename/ModelRenameComponent/sw-model-rename.vue"
export default component.exports